import React, { useEffect, useState } from 'react';
import { BackButton } from '../../common/back-button/back-button';
import SecondaryButton from '../../common/buttons/SecondaryButton';
import { Toast } from "../../common/toast/toast";

const Recruiter = ({ currentRecruiterId, recruiterData,
  fetchRecruiterPayload,
  setfetchRecruiterPayload,
  fetchEvents,
  selectedValue,
  isRecruiterOpen,
  setIsRecruiterOpen,
  selectedRecruiterId,
  setSelectedRecruiterId,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  clearFilter,
  setClearFilter,
  addToast,
  recID
}) => {
  const [error, setError] = useState({ date: '', recruiter: '' })
  function validateDates(startDate, endDate, selectedRecruiterId, setError) {
    let newErrors = { recruiter: "", date: "" }; // Reset errors first

    if (!selectedRecruiterId && selectedValue !== "single") {
      newErrors.recruiter = "Please select recruiter.";
    }

    if (!startDate || !endDate) {
      newErrors.date = "Please select start date and end date.";
    } else {
      const start = new Date(startDate);
      const end = new Date(endDate);
      if (end < start) {
        newErrors.date = "End date cannot be before start date.";
      }
    }

    setError(newErrors); // Update errors

    return !newErrors.recruiter && !newErrors.date; // Return true if no errors
  }

  const handleRecruiterChange = (e) => {
    setSelectedRecruiterId(e.target.value);
  };

  const convertToUTC = (dateTime) => {
    return new Date(dateTime).toISOString();
  };

  const handleSubmit = () => {
    const recPayload = selectedValue === "single" ? { recruiterID: currentRecruiterId, startDate: convertToUTC(startDate), endDate: convertToUTC(endDate) } : {
      recruiterID: selectedRecruiterId,
      startDate: convertToUTC(startDate),
      endDate: convertToUTC(endDate),
    };

    const isValid = validateDates(startDate, endDate, selectedRecruiterId, setError, error);
    if (isValid) {
      //console.log("Proceed with form submission.");
    } else {
      return
    }
    setfetchRecruiterPayload(recPayload);
    fetchEvents(selectedValue, recPayload);
    addToast("The Recruiter calendar has been fetched successfully", "success");
    setIsRecruiterOpen(false);
    setClearFilter(true);

  };

  const handleClearFilter = () => {
    setSelectedRecruiterId("");
    const currentTime = new Date().toISOString().slice(0, 16);
    let payload = selectedValue === "single" ? { recruiterID: currentRecruiterId, startDate: null, endDate: null } : { recruiterID: null, startDate: null, endDate: null }
    setStartDate(currentTime);
    setEndDate(currentTime);
    setClearFilter(false);
    setfetchRecruiterPayload(payload);
    fetchEvents(selectedValue, payload);
    addToast("The Filter has been cleared", "success");
    setIsRecruiterOpen(false);

  };

  const closePopup = () => {
    setIsRecruiterOpen(false);
  };


  return (
    <div className="mt-4 bg-white shadow-md rounded-lg p-4 h-[calc(100vh-80px)] overflow-scroll relative z-30">

      <h2 className="agendaTitle text-lg font-bold">Filter Recruiter</h2>

      <div className="w-full relative">
        <label htmlFor="recruiterName" className="block form_label_color mb-1 mt-3">
          Recruiter Name <span className="aestrick_color">*</span>
        </label>
        <div className="border_color border text-base rounded-lg block w-full p-0 appearance-none mb-4">
          <select
            id="recruiterId"
            name="recruiterId"
            value={selectedValue === "single" ? recID ? recID : '' : selectedRecruiterId}
            onChange={handleRecruiterChange}
            disabled={selectedValue === "single"}
            className="text-base rounded-lg block w-full p-2.5 h-12 appearance-none w-full"
          >
            {selectedValue === "single" ?<option value="" disabled>
              
            </option>:<option value="" disabled>
              Select a recruiter
            </option>}
            {recruiterData.map((rd) => (
              <option key={rd.recruiterID} value={rd.recruiterID}>
                {rd.firstName} {rd.lastName}
              </option>
            ))}
          </select>
          {selectedValue === "single" ? '' : <span className="absolute right-[20px] top-[50px] transform -translate-y-1/2 pointer-events-none">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995" stroke="#245CEA" strokeWidth="2" stroke-miterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </span>}
        </div>
        {error.recruiter && <p className="text-[#F95454] font-mont text-[14px] font-[500] mt-2">{error.recruiter}</p>}
      </div>

      <label htmlFor="startDate" className="block form_label_color mb-1 mt-4">
        Start Date & Time
      </label>
      <input
        type="datetime-local"
        id="startDate"
        value={startDate}
        onChange={(e) => setStartDate(e.target.value)}
        className="border rounded-lg block w-full p-2.5 h-12  mb-3"
      />

      <label htmlFor="endDate" className="block form_label_color mb-1 mt-4">
        End Date & Time
      </label>
      <input
        type="datetime-local"
        id="endDate"
        value={endDate}
        onChange={(e) => setEndDate(e.target.value)}
        className="border rounded-lg block w-full p-2.5 mb-3"
      />
      {error.date && <p className="text-[#F95454] font-mont text-[14px] font-[500] mt-2">{error.date}</p>}

      {clearFilter && (
        <button onClick={handleClearFilter} className="bg-red-500 text-white px-4 py-2 rounded mt-3">
          Clear the Filter
        </button>
      )}

      <div className="absolute shadow-[0_-4px_20px_0_rgba(0,0,0,0.25)] p-5 bottom-[0] right-[0] w-full bg-white flex gap-5">
        <button
          onClick={handleSubmit}
          className="btn-primary-base-bar primary_btn flex items-center bg-[#245CEA] text-white py-2 px-5 rounded-[5px] hover:bg-white border hover:border-[#245CEA] hover:text-[#1A1A1B] transition duration-300 h-[42px] text-[16px] font-mont font-[600]"
        >
          Submit
        </button>
        <SecondaryButton label="Cancel" onClick={closePopup} />
      </div>
    </div>
  );
};

export default Recruiter;
